var map = {
	"./environment.dev": 653,
	"./environment.dev.ts": 653,
	"./environment.local": 7691,
	"./environment.local.ts": 7691,
	"./environment.stage": 8569,
	"./environment.stage.ts": 8569,
	"./environment.ts": 1702
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 148;